import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from "react-helmet-async";
import defaultImage from "@sprout/assets/images/meta-image.png";
import imageCache from "sprout-lib/dist/image-cache";
function imageURL(url) {
    const url2 = url || defaultImage;
    return process.env.NODE_ENV === "development" ? url2 : imageCache(`${process.env.ROOT_URL}/${url2}`);
}
const Head = (props)=>{
    const { title , description , children , image , type  } = props;
    return /*#__PURE__*/ _jsxs(Helmet, {
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: title
            }),
            description && /*#__PURE__*/ _jsx("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ _jsx("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ _jsx("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ _jsx("meta", {
                property: "og:image",
                content: imageURL(image)
            }),
            /*#__PURE__*/ _jsx("meta", {
                property: "og:type",
                content: type || "website"
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ _jsx("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "twitter:image",
                content: imageURL(image)
            }),
            children
        ]
    });
};
export default Head;
